export const CHANGE_GLOBAL_STATE = "CHANGE_GLOBAL_STATE";
export const CHANGE_LOADING_DATA = "CHANGE_LOADING_DATA";
export const CHANGE_ERROR_DATA = "CHANGE_ERROR_DATA";

export const SET_IND_VALIDACION = "SET_IND_VALIDACION";
export const SHOW_MODAL_LOADING = "SHOW_MODAL_LOADING";

export const SET_VIEW_MODAL_ERROR = "SET_VIEW_MODAL_ERROR";

export const SET_RELATIONSHIP_LIST = "SET_RELATIONSHIP_LIST";

export const SET_PAYMENT_SUBSCRIBED = "SET_PAYMENT_SUBSCRIBED";

export const SET_IS_FIRST_TIME_VIEWING_PLANS = "SET_IS_FIRST_TIME_VIEWING_PLANS";
